(() => {
  const state = {
    reasons: new Set(),
    hideOnBodyClasses: ['page-cart'],
    widget: {
      hostSelector: '#ShopifyChat',
      shadowSelector: 'button.chat-toggle.chat-toggle--icon-button'
    },
    observer: null
  };

  const setElementHidden = (element, shouldHide) => {
    if (!element) return;
    element.style.display = shouldHide ? 'none' : '';
  };

  const applyWidgetVisibility = (shouldHide) => {
    const host = document.querySelector(state.widget.hostSelector);
    if (host) {
      setElementHidden(host, shouldHide);
      if (host.shadowRoot && state.widget.shadowSelector) {
        const shadowToggle = host.shadowRoot.querySelector(state.widget.shadowSelector);
        setElementHidden(shadowToggle, shouldHide);
      }
    }
  };

  const updateVisibility = () => {
    if (!document.body) return;
    const hideForBodyClass = state.hideOnBodyClasses.some((className) =>
      document.body.classList.contains(className)
    );
    const shouldHide = hideForBodyClass || state.reasons.size > 0;
    document.body.classList.toggle('chat-widget-hidden', shouldHide);
    applyWidgetVisibility(shouldHide);
  };

  const setReason = (key, isHidden) => {
    if (!key) return;
    if (isHidden) {
      state.reasons.add(key);
    } else {
      state.reasons.delete(key);
    }
    updateVisibility();
  };

  const addBodyClassCondition = (className) => {
    if (!className || state.hideOnBodyClasses.includes(className)) return;
    state.hideOnBodyClasses.push(className);
    updateVisibility();
  };

  const removeBodyClassCondition = (className) => {
    const index = state.hideOnBodyClasses.indexOf(className);
    if (index === -1) return;
    state.hideOnBodyClasses.splice(index, 1);
    updateVisibility();
  };

  const startObserver = () => {
    if (!document.body || state.observer) return;
    state.observer = new MutationObserver(() => updateVisibility());
    state.observer.observe(document.body, { childList: true, subtree: true });
  };

  const init = () => {
    updateVisibility();
    startObserver();
  };

  window.ChatWidgetVisibility = {
    setReason,
    update: updateVisibility,
    addBodyClassCondition,
    removeBodyClassCondition
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
